import { Satisfaction } from 'lib-shared-legacy-types';
import { PureComponent } from 'react';

import { ScoreIcon } from 'fable/ScoreIcon';

import style from './index.module.scss';

type Props = {
  thankYouText: string;
  ratingStyle?: Satisfaction.RatingStyle;
};

type State = {};

const defaultRatingStyle: Satisfaction.RatingStyle = 'emojis';

export class ThankYouPreview extends PureComponent<Props, State> {
  render() {
    const { thankYouText, ratingStyle = defaultRatingStyle } = this.props;

    return (
      <div className={style.backdrop}>
        <section className={style.feedbackWrapper}>
          <ScoreIcon style={ratingStyle} score={4} size={40} showAll />
          <div className={style.thankYouText} dir="auto">
            {thankYouText}
          </div>
        </section>
      </div>
    );
  }
}
